import { render, staticRenderFns } from "./ArbitraryStatus.vue?vue&type=template&id=30c1745f&"
import script from "./ArbitraryStatus.vue?vue&type=script&lang=js&"
export * from "./ArbitraryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports